import AppError from '../errors/AppError';
import IHubSpotPipeline from '../interfaces/IHubSpotPipeline';
import { IPaginationReturn } from '../interfaces/IPaginationReturn';

import { useRequest } from './useRequest';

const useHubSpotPipelineService = () => {
  const request = useRequest<IHubSpotPipeline>();
  const path = 'hubspot-pipelines';

  const findAllHubSpotPipeline = async (queryParams: string): Promise<IPaginationReturn<IHubSpotPipeline[]>> => {
    return await request
      .getManyPaginated({ path: `${path}?${queryParams}`, sendAuthorization: true })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const createHubSpotPipeline = async (pipeline: IHubSpotPipeline): Promise<IHubSpotPipeline> => {
    return await request
      .post({ path: `${path}`, sendAuthorization: true, body: pipeline })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const updateHubSpotPipeline = async (id: string, pipeline: IHubSpotPipeline): Promise<IHubSpotPipeline> => {
    return await request
      .put({ path: `${path}/${id}`, sendAuthorization: true, body: pipeline })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const deleteHubSpotPipeline = async (id: string): Promise<void> => {
    return await request
      .remove({ path: `${path}/${id}`, sendAuthorization: true })
      .then(() => undefined)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const findHubSpotPipeline = async (id: string): Promise<IHubSpotPipeline> => {
    return await request
      .getOne({ path: `${path}/${id}`, sendAuthorization: true })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  return {
    findAllHubSpotPipeline,
    updateHubSpotPipeline,
    findHubSpotPipeline,
    createHubSpotPipeline,
    deleteHubSpotPipeline,
  };
};

export { useHubSpotPipelineService };
